var chunkPrefetchChunkToChildrenMap = {"5090":[7863,7863],"3004":[7863,3771,7604],"2709":[7863,3771],"1895":[7863,9886],"9481":[7863,1862],"2717":[7863],"7526":[7863],"4998":[2478],"9852":[7863],"1793":[7863],"4606":[5383,716,9948],"9948":[7863],"3468":[7863],"9841":[7863,3771]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkPrefetchChunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};
